/* eslint-disable */
import React from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import './style.css';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';
import { useTranslation } from 'utils/modifiedTranslation';
import { OPEN_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { useMatchesFilter } from 'modules/matchesFilter/MatchesFilterContext';
import { preserveQueryParam } from 'functions/preserveQueryParam';
import app from 'new-ui/app';
import WidgetBtn from '../Button';
import Button from 'new-ui/Components/Button';
import AssistanceButton from '../AssistanceButton';
import Chemo from 'assets/icons/treatments/chemo.svg';
import Targeted from 'assets/icons/treatments/targeted.svg';
import Immuno from 'assets/icons/treatments/immuno.svg';
import Radiation from 'assets/icons/treatments/radiation.svg';
import Combo from 'assets/icons/treatments/combo.svg';
import OptionCheckbox from 'new-ui/TreatmentOptions/Checkbox';
import { isTreatmentTrialDisabled } from 'new-ui/functions';

const options = [
  {
    id: 1,
    value: 'chemotherapy',
    label: 'Chemo',
    color: '#E2DAFF',
    icon: Chemo
  },
  {
    id: 2,
    value: 'targeted_therapy',
    label: 'Targeted',
    color: '#FBDBE0',
    icon: Targeted
  },
  {
    id: 3,
    value: 'immunotherapy',
    label: 'Immuno',
    color: '#FDF6E2',
    icon: Immuno
  },
  {
    id: 4,
    value: 'radiation',
    label: 'Radiation',
    color: '#F5FAEA',
    icon: Radiation
  },
  {
    id: 5,
    value: 'vaccine',
    label: 'Vaccine',
    color: '#D5F3F0',
    icon: Combo
  }
];

const getPreferencesCount = (treatments, trials) => {
  let count = trials?.length ?? 0;
  if (!isTreatmentTrialDisabled()) {
    count += treatments?.length ?? 0;
  }
  return count;
};

const PreferencesWidget = ({ treatments, trials }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { interventionalTypes, setInterventionalTypes } = useMatchesFilter();

  const handleCheckboxChange = (optionValue) => {
    setInterventionalTypes((currentInterventionalTypes) => {
      const optionIndex = currentInterventionalTypes.findIndex((i) => i === optionValue);
      return optionIndex === -1
        ? [...currentInterventionalTypes, optionValue]
        : [...currentInterventionalTypes.slice(0, optionIndex), ...currentInterventionalTypes.slice(optionIndex + 1)];
    });
  };

  return (
      <div className="preference-widget">
          <div className="options-header">
              <div className="options-count">
                  <div className="count">{getPreferencesCount(treatments, trials)}</div>
                  <span className="divider">/</span>
                  <div className="label">{t('preferences_widget.sub_title')}</div>
              </div>
          </div>
          <div className="options-body">
              <h2 className="title">{t('preferences_widget.title')}</h2>
              <h3 className="sub-title">
                  {t('preferences_widget.description')}
              </h3>

              <ul className='options-list'>
                  {options.map((option) => (
                      <li key={option.value} className='options-item'>
                          <div className='option-icon' style={{ backgroundColor: option.color }}>
                              <img src={option.icon} alt='icon' />
                          </div>
                          <OptionCheckbox
                              label={option.label}
                              checked={interventionalTypes.includes(option.value)}
                              onChange={() => handleCheckboxChange(option.value)}
                          />
                      </li>
                  ))}
              </ul>
          </div>
          <div className="options-footer">
              <Button
                backgroundColor="#FFF"
                color="#213332"
                width="180px"
                className="btn btn-more-options"
                title={t('preferences_widget.actions.more_options.button')}
                action={() => {
                  dispatch(push(preserveQueryParam(
                    ROUTE_PATH[ROUTE_NAME.RESULTS],
                    { extra: [[OPEN_URL_SEARCH_PARAM, 'interventional_types']] },
                  )));
                }}
              />
              <WidgetBtn
                title={t('preferences_widget.actions.my_options.button')}
                onClick={() => {
                  dispatch(push(ROUTE_PATH[ROUTE_NAME.RESULTS]));
                }}
              />
              <AssistanceButton title={t('preferences_widget.actions.assistance.button')} onClick={()=>{ app.cache.assistTrigBy = 'preference'; }} />
          </div>
      </div>
  );
};
export default PreferencesWidget;
